// extracted by mini-css-extract-plugin
export default {"Sort":"Sort_Sort__GwQtz","label":"Sort_label__9UBxc"};